<template>
    <div class="decorative-separator">
        <img src="../assets/images/separator.svg" alt="Decorative Separator" class="separator-image" />
    </div>
</template>

<script>
export default {
    name: "DecorativeSeparator"
}
</script>

<style scoped>
.decorative-separator {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
}

.separator-image {
    width: 100%;
    max-width: 300px;
    height: auto;
    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.15));
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .decorative-separator {
        padding: 1.5rem 0;
        margin: 0.5rem 0;
    }
}

@media (max-width: 480px) {
    .decorative-separator {
        padding: 1rem 0;
    }
}
</style>
